module.exports = __webpack_public_path__ + "img/target-me.0127d79d.svg";